module.exports = __webpack_public_path__ + "img/120.15991b75.jpg";